import { useQuery } from 'react-query';
import { http } from '..';

export default (date, enabled = true) => {
  const data = useQuery(
    ['availableBookings', date],
    async () => {
      const response = await http.get(`/courts/availableByDate/${date}`);
      return response.data;
    },
    { enabled: enabled }
  );

  return data;
};
